/** scripts/prepare-textures.py が生成する。手で編集しない。 */

export interface TexturedMaterialEntry {
  id: string;
  label: string;
  color: number;
  roughness: number;
  metalness: number;
  maps: string;
  tileSize?: number;
}

export interface TexturePack {
  id: string;
  label: string;
  materials: TexturedMaterialEntry[];
}

export const TEXTURE_PACKS: TexturePack[] = [
  {
    id: 'mix-pack-02',
    label: 'Tiles & Metal',
    materials: [
      {
        id: 'laminated-wood',
        label: '積層木材',
        color: 0x8b7355,
        roughness: 1,
        metalness: 1,
        maps: '/textures/laminated-wood',
      },
      {
        id: 'metal-bump',
        label: 'バンプメタル',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-bump',
      },
      {
        id: 'metal-horizontal-bump',
        label: '横縞バンプメタル',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-horizontal-bump',
      },
      {
        id: 'metal-horizontal',
        label: '横縞メタル',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-horizontal',
      },
      {
        id: 'terrazzo-curved',
        label: '曲線テラゾ',
        color: 0x808080,
        roughness: 1,
        metalness: 1,
        maps: '/textures/terrazzo-curved',
      },
      {
        id: 'terrazzo-long',
        label: '長尺テラゾ',
        color: 0x808080,
        roughness: 1,
        metalness: 1,
        maps: '/textures/terrazzo-long',
      },
      {
        id: 'terrazzo-rough',
        label: '粗目テラゾ',
        color: 0x808080,
        roughness: 1,
        metalness: 1,
        maps: '/textures/terrazzo-rough',
      },
      {
        id: 'terrazzo-tiles',
        label: 'テラゾタイル',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/terrazzo-tiles',
      },
      {
        id: 'weaved-basket',
        label: '籠編み',
        color: 0x808080,
        roughness: 1,
        metalness: 1,
        maps: '/textures/weaved-basket',
      },
    ],
  },
  {
    id: 'mix-pack-01',
    label: 'Tiles & Stones',
    materials: [
      {
        id: 'concrete-stones-01',
        label: 'コンクリート石',
        color: 0x8a8a88,
        roughness: 1,
        metalness: 1,
        maps: '/textures/concrete-stones-01',
      },
      {
        id: 'decorative-bricks-01',
        label: '装飾レンガ',
        color: 0xa4523f,
        roughness: 1,
        metalness: 1,
        maps: '/textures/decorative-bricks-01',
      },
      {
        id: 'paint-copper-01',
        label: '塗装銅',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/paint-copper-01',
      },
      {
        id: 'plaster-01',
        label: '漆喰',
        color: 0x8a8a88,
        roughness: 1,
        metalness: 1,
        maps: '/textures/plaster-01',
      },
      {
        id: 'sidewalk-brick-tiles-01',
        label: '歩道レンガタイル1',
        color: 0xa4523f,
        roughness: 1,
        metalness: 1,
        maps: '/textures/sidewalk-brick-tiles-01',
      },
      {
        id: 'sidewalk-brick-tiles-02',
        label: '歩道レンガタイル2',
        color: 0xa4523f,
        roughness: 1,
        metalness: 1,
        maps: '/textures/sidewalk-brick-tiles-02',
      },
      {
        id: 'sidewalk-brick-tiles-03',
        label: '歩道レンガタイル3',
        color: 0xa4523f,
        roughness: 1,
        metalness: 1,
        maps: '/textures/sidewalk-brick-tiles-03',
      },
      {
        id: 'sidewalk-tiles-01',
        label: '歩道タイル',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/sidewalk-tiles-01',
      },
      {
        id: 'tiles-01',
        label: 'タイル',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/tiles-01',
      },
    ],
  },
  {
    id: 'mix-pack-03',
    label: 'Tiles & Roaches',
    materials: [
      {
        id: 'bricks-destroyed',
        label: '崩れたレンガ',
        color: 0xa4523f,
        roughness: 1,
        metalness: 1,
        maps: '/textures/bricks-destroyed',
      },
      {
        id: 'bricks-destroyed-plaster',
        label: '崩れた漆喰レンガ',
        color: 0xa4523f,
        roughness: 1,
        metalness: 1,
        maps: '/textures/bricks-destroyed-plaster',
      },
      {
        id: 'colored-tiles-small',
        label: '色タイル（小）',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/colored-tiles-small',
      },
      {
        id: 'fabric-square-patterrn',
        label: '四角模様ファブリック',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/fabric-square-patterrn',
      },
      {
        id: 'ground-bricks-herringbone',
        label: 'ヘリンボーンレンガ',
        color: 0xa4523f,
        roughness: 1,
        metalness: 1,
        maps: '/textures/ground-bricks-herringbone',
      },
      {
        id: 'terrazo-tiles-decorative',
        label: '装飾テラゾ',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/terrazo-tiles-decorative',
      },
      {
        id: 'terrazo-tiles-gray',
        label: '灰色テラゾ',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/terrazo-tiles-gray',
      },
    ],
  },
  {
    id: 'mix-pack-04',
    label: 'Leather & Metal',
    materials: [
      {
        id: 'armor-scales-decorated',
        label: '装飾鱗甲',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/armor-scales-decorated',
      },
      {
        id: 'armor-scales-simple',
        label: '鱗甲',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/armor-scales-simple',
      },
      {
        id: 'decorative-ceramic-tiles',
        label: '装飾セラミックタイル',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/decorative-ceramic-tiles',
      },
      {
        id: 'decorative-concrete-bricks',
        label: '装飾コンクリートレンガ',
        color: 0xa4523f,
        roughness: 1,
        metalness: 1,
        maps: '/textures/decorative-concrete-bricks',
      },
      {
        id: 'decorative-fabric',
        label: '装飾ファブリック',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/decorative-fabric',
      },
      {
        id: 'leather-cross',
        label: '十字レザー',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/leather-cross',
      },
      {
        id: 'leather-straps',
        label: 'レザーストラップ',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/leather-straps',
      },
      {
        id: 'leather-straps-pattern',
        label: 'レザーストラップ模様',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/leather-straps-pattern',
      },
      {
        id: 'metal-grater',
        label: 'グレーターメタル',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-grater',
      },
    ],
  },
  {
    id: 'mix-pack-05',
    label: 'Wood & Windows',
    materials: [
      {
        id: 'ceramic-tiles-circular',
        label: '円形セラミックタイル',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/ceramic-tiles-circular',
      },
      {
        id: 'dark-wood-floor-tiles',
        label: '暗い木の床タイル',
        color: 0x8b7355,
        roughness: 1,
        metalness: 1,
        maps: '/textures/dark-wood-floor-tiles',
      },
      {
        id: 'decorative-bathroom-tiles',
        label: '浴室タイル',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/decorative-bathroom-tiles',
      },
      {
        id: 'decorative-black-tiles',
        label: '黒タイル',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/decorative-black-tiles',
      },
      {
        id: 'old-rug-brown',
        label: '茶色の古いラグ',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/old-rug-brown',
      },
      {
        id: 'retractable-security-door',
        label: 'セキュリティドア',
        color: 0x808080,
        roughness: 1,
        metalness: 1,
        maps: '/textures/retractable-security-door',
      },
      {
        id: 'window-grill',
        label: '窓格子',
        color: 0x4a5a6a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/window-grill',
      },
      {
        id: 'wodden-framed-window',
        label: '木枠窓',
        color: 0x4a5a6a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/wodden-framed-window',
      },
      {
        id: 'wodden-framed-windows',
        label: '木枠窓（連）',
        color: 0x4a5a6a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/wodden-framed-windows',
      },
    ],
  },
  {
    id: 'mix-pack-06',
    label: 'Mix Pack 06',
    materials: [
      {
        id: 'concrete-fish-tiles',
        label: '魚模様コンクリート',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/concrete-fish-tiles',
      },
      {
        id: 'leather-couchin-perfored',
        label: '穴あきレザー',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/leather-couchin-perfored',
      },
      {
        id: 'leather-couchin-perfored-diamond',
        label: 'ダイヤ穴あきレザー',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/leather-couchin-perfored-diamond',
      },
      {
        id: 'leather-couchin-rectangle',
        label: '四角レザー',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/leather-couchin-rectangle',
      },
      {
        id: 'leather-couchin-scales',
        label: '鱗レザー',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/leather-couchin-scales',
      },
      {
        id: 'metal-cooper-grid',
        label: '銅グリッド',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-cooper-grid',
      },
      {
        id: 'stylized-clover-ground',
        label: 'クローバー地面',
        color: 0x808080,
        roughness: 1,
        metalness: 1,
        maps: '/textures/stylized-clover-ground',
      },
      {
        id: 'terrazo-and-white-tiles',
        label: '白タイル混テラゾ',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/terrazo-and-white-tiles',
      },
      {
        id: 'tire-rubber',
        label: 'タイヤゴム',
        color: 0x808080,
        roughness: 1,
        metalness: 1,
        maps: '/textures/tire-rubber',
      },
    ],
  },
  {
    id: 'mix-pack-07',
    label: 'Mix Pack 07',
    materials: [
      {
        id: 'fabric-decorative-01',
        label: '装飾ファブリック1',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/fabric-decorative-01',
      },
      {
        id: 'fabric-decorative-02',
        label: '装飾ファブリック2',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/fabric-decorative-02',
      },
      {
        id: 'fabric-decorative-03',
        label: '装飾ファブリック3',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/fabric-decorative-03',
      },
      {
        id: 'fabric-scify-01',
        label: 'SFファブリック',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/fabric-scify-01',
      },
      {
        id: 'fabric-wool-01',
        label: 'ウール',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/fabric-wool-01',
      },
      {
        id: 'floor-tiles-and-bricks',
        label: 'タイルとレンガの床',
        color: 0xa4523f,
        roughness: 1,
        metalness: 1,
        maps: '/textures/floor-tiles-and-bricks',
      },
      {
        id: 'leather-couching-01',
        label: 'キルティングレザー',
        color: 0x6a4a3a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/leather-couching-01',
      },
      {
        id: 'wall-plaster-stones',
        label: '漆喰石壁',
        color: 0x8a8a88,
        roughness: 1,
        metalness: 1,
        maps: '/textures/wall-plaster-stones',
      },
      {
        id: 'windows-blue-old',
        label: '古い青窓',
        color: 0x4a5a6a,
        roughness: 1,
        metalness: 1,
        maps: '/textures/windows-blue-old',
      },
    ],
  },
  {
    id: 'metal-pack-02',
    label: 'Metal Grids',
    materials: [
      {
        id: 'metal-grid-clover',
        label: 'メタルグリッド（クローバー）',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-grid-clover',
      },
      {
        id: 'metal-grid-cross',
        label: 'メタルグリッド（十字）',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-grid-cross',
      },
      {
        id: 'metal-grid-spikes',
        label: 'メタルグリッド（スパイク）',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-grid-spikes',
      },
      {
        id: 'metal-grid-square',
        label: 'メタルグリッド（四角）',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-grid-square',
      },
      {
        id: 'metal-grid-square-white',
        label: 'メタルグリッド（白四角）',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-grid-square-white',
      },
      {
        id: 'metal-grid-wave',
        label: 'メタルグリッド（波）',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-grid-wave',
      },
      {
        id: 'metal-shutter-cross-bars',
        label: 'シャッター（十字）',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-shutter-cross-bars',
      },
      {
        id: 'metal-shutter-perfored-roller',
        label: 'シャッター（穴あき）',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-shutter-perfored-roller',
      },
      {
        id: 'metal-shutter-perfored-roller-big',
        label: 'シャッター（大穴）',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-shutter-perfored-roller-big',
      },
    ],
  },
  {
    id: 'tiles-and-metals',
    label: 'Metal & Tiles',
    materials: [
      {
        id: 'metal-tiles-solded',
        label: '溶接メタルタイル',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-tiles-solded',
      },
      {
        id: 'metal-triangle-solded',
        label: '溶接三角メタル',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-triangle-solded',
      },
      {
        id: 'metal-zinc-rough',
        label: '粗い亜鉛',
        color: 0x5c5f63,
        roughness: 1,
        metalness: 1,
        maps: '/textures/metal-zinc-rough',
      },
      {
        id: 'sponge',
        label: 'スポンジ',
        color: 0x808080,
        roughness: 1,
        metalness: 1,
        maps: '/textures/sponge',
      },
      {
        id: 'stone-floor-polished',
        label: '磨き石床',
        color: 0x8a8a88,
        roughness: 1,
        metalness: 1,
        maps: '/textures/stone-floor-polished',
      },
      {
        id: 'tiles-basic-01',
        label: 'ベーシックタイル',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/tiles-basic-01',
      },
      {
        id: 'tiles-diamond-moon',
        label: 'ダイヤタイル',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/tiles-diamond-moon',
      },
      {
        id: 'tiles-marble-01',
        label: '大理石タイル1',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/tiles-marble-01',
      },
      {
        id: 'tiles-marble-02',
        label: '大理石タイル2',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/tiles-marble-02',
      },
    ],
  },
  {
    id: 'wood-and-bricks',
    label: 'Bricks & Wood',
    materials: [
      {
        id: 'concrete-destroyed-wall-01',
        label: '崩れたコンクリート壁',
        color: 0x8a8a88,
        roughness: 1,
        metalness: 1,
        maps: '/textures/concrete-destroyed-wall-01',
      },
      {
        id: 'old-bricks-01',
        label: '古いレンガ',
        color: 0xa4523f,
        roughness: 1,
        metalness: 1,
        maps: '/textures/old-bricks-01',
      },
      {
        id: 'stone-engrave-wall-01',
        label: '彫刻石壁',
        color: 0x8a8a88,
        roughness: 1,
        metalness: 1,
        maps: '/textures/stone-engrave-wall-01',
      },
      {
        id: 'wood-and-bricks-floor-01',
        label: '木とレンガの床',
        color: 0x8b7355,
        roughness: 1,
        metalness: 1,
        maps: '/textures/wood-and-bricks-floor-01',
      },
      {
        id: 'wooden-floor-painted-01',
        label: '塗装木の床',
        color: 0x8b7355,
        roughness: 1,
        metalness: 1,
        maps: '/textures/wooden-floor-painted-01',
      },
      {
        id: 'wooden-floor-01',
        label: '木の床1',
        color: 0x8b7355,
        roughness: 1,
        metalness: 1,
        maps: '/textures/wooden-floor-01',
      },
      {
        id: 'wooden-floor-02',
        label: '木の床2',
        color: 0x8b7355,
        roughness: 1,
        metalness: 1,
        maps: '/textures/wooden-floor-02',
      },
      {
        id: 'wooden-floor-03',
        label: '木の床3',
        color: 0x8b7355,
        roughness: 1,
        metalness: 1,
        maps: '/textures/wooden-floor-03',
      },
      {
        id: 'wooden-floor-04',
        label: '木の床4',
        color: 0x8b7355,
        roughness: 1,
        metalness: 1,
        maps: '/textures/wooden-floor-04',
      },
    ],
  },
  {
    id: 'stone-tiles',
    label: 'Stone Tiles',
    materials: [
      {
        id: 'stone-tiles-01',
        label: '石タイル1',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/stone-tiles-01',
      },
      {
        id: 'stone-tiles-02',
        label: '石タイル2',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/stone-tiles-02',
      },
      {
        id: 'stone-tiles-03',
        label: '石タイル3',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/stone-tiles-03',
      },
      {
        id: 'stone-tiles-04',
        label: '石タイル4',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/stone-tiles-04',
      },
      {
        id: 'stone-tiles-05',
        label: '石タイル5',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/stone-tiles-05',
      },
      {
        id: 'stone-tiles-06',
        label: '石タイル6',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/stone-tiles-06',
      },
      {
        id: 'stone-tiles-07',
        label: '石タイル7',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/stone-tiles-07',
      },
      {
        id: 'stone-tiles-08',
        label: '石タイル8',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/stone-tiles-08',
      },
      {
        id: 'stone-tiles-09',
        label: '石タイル9',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/stone-tiles-09',
      },
    ],
  },
  {
    id: 'base-white-tile',
    label: 'White Tile',
    materials: [
      {
        id: 'base-white-tile',
        label: '白いタイル',
        color: 0x7a7a78,
        roughness: 1,
        metalness: 1,
        maps: '/textures/base-white-tile',
        tileSize: 2,
      },
    ],
  },
];
